import script from "./CertificatePayout.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificatePayout.vue?vue&type=script&setup=true&lang=js"

import "./CertificatePayout.vue?vue&type=style&index=0&id=28ebae26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28ebae26"]])

export default __exports__